import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const offer = useConnect('offer.byId', {
    id: Number(match.params.offerId)
  })

  if (offer.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      offer={offer}
      page="Cost"
      title="Does your offer have any costs to educators or students?"
      // description={(
      //   <>
      //     While we love when individuals, businesses, and organizations offer workshops,
      //     resources, and other activities for no charge to students and educators, we know
      //     that this isn't always possible.
      //   </>
      // )}
    >
      <Form
        user={user}
        offer={offer}
        navigation={(
          <Navigation v5={true} activeStep={14} steps={16}/>
        )}
        onPrevious={(newData) => history.push(Urls(offer).LOCATION)}
        onNext={(newData) => history.push(Urls(offer).DOCUMENTS)}
        onSkip={() => history.push(Urls(offer).DOCUMENTS)}
        onExit={() => history.push(Urls(offer).OFFER_EDIT)}
      />
    </ParentLayout>
  );
};
